import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostFinanceAddinfoAccountsRequestModel, PostFinanceAddinfoAccountsResponseModel } from "@/features/accounts/finance/services/post-addinfo-accounts-model";

export class PostFinanceAddinfoAccountsApi {
  /**
   * 銀行口座登録API
   */
  public postFinanceAddinfoAccounts = async (
    param: PostFinanceAddinfoAccountsRequestModel
  ): Promise<PostFinanceAddinfoAccountsResponseModel> => {
    const path = `/api/financeaccounts/finances/accounts`;
    const res = await ApiClient.instance.post<PostFinanceAddinfoAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
